import React, { useState, useContext } from 'react';
import {
    Anchor,
    Box,
    Button,
    Form,
    FormField,
    Image,
    Main,
    Page,
    PageContent,
    ResponsiveContext,
    TextInput,
} from 'grommet';
import { Key, MailOption } from 'grommet-icons';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { AppConstants, hasToken } from '@enrich/shared-lib';
import BannerLogo from '../enrichLogo.png';
import MarketingImage from '../photo_marketing_presentation.jpg';

export const Login = () => {
    const { companySlug } = useParams();
    const size = useContext(ResponsiveContext);
    const isMobile = size === 'small';
    const [value, setValue] = useState({ email: '', password: '' });
    const [buttonBusy, setButtonBusy] = useState(false);
    const [formError, setFormError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setButtonBusy(true);
        try {
            const loginResponse = await axios.post(
                `${process.env.REACT_APP_ENRICH_CMS_ENDPOINT}/api/auth/local`,
                {
                    identifier: value.email,
                    password: value.password,
                    companySlug,
                },
            );

            localStorage.setItem(
                AppConstants.cacheKeys.authToken,
                loginResponse.data.jwt,
            );
            localStorage.setItem(
                AppConstants.cacheKeys.userId,
                loginResponse.data.user.id,
            );

            const { tempPasswordChanged } = loginResponse.data.user;
            if (!tempPasswordChanged) {
                navigate(`/${companySlug}/change-password`);
            } else {
                navigate(`/${companySlug}/dashboard`);
            }
        } catch (error) {
            setFormError(
                error?.response?.data?.error?.message ||
                    error?.message ||
                    'There was an issue with authentication.',
            );
        }
        setButtonBusy(false);
    };

    return (
        <Main>
            <Page kind="full" height="100vh" background="enrich-grey">
                <PageContent pad="none" height="100%" justify="center">
                    <Box direction="row">
                        {!isMobile && (
                            <Box>
                                <Image
                                    src={MarketingImage}
                                    height="100%"
                                    fit="cover"
                                />
                            </Box>
                        )}
                        <Box
                            background="white"
                            round="15px"
                            width="100%"
                            pad="large"
                            margin="medium"
                            align="stretch"
                            justify="evenly"
                            gap="small">
                            <Image
                                src={BannerLogo}
                                width="200px"
                                alignSelf="center"
                            />
                            <Form
                                value={value}
                                onChange={(nextValue) => setValue(nextValue)}
                                onSubmit={handleSubmit}>
                                <Box gap="10px">
                                    <FormField
                                        name="email"
                                        htmlFor="email-input-id"
                                        label="Email">
                                        <TextInput
                                            name="email"
                                            id="email-input-id"
                                            icon={<MailOption />}
                                        />
                                    </FormField>
                                    <FormField
                                        name="password"
                                        htmlFor="password-input-id"
                                        label="Password"
                                        error={formError}>
                                        <TextInput
                                            name="password"
                                            id="password-input-id"
                                            type="password"
                                            icon={<Key />}
                                        />
                                    </FormField>
                                    <Button
                                        type="submit"
                                        primary
                                        fill="horizontal"
                                        label="Login"
                                        busy={buttonBusy}
                                    />
                                    <Anchor
                                        label="Forgot password?"
                                        alignSelf="center"
                                        onClick={() =>
                                            navigate(
                                                `/${companySlug}/forgot-password`,
                                            )
                                        }
                                    />
                                </Box>
                            </Form>
                        </Box>
                    </Box>
                </PageContent>
            </Page>
        </Main>
    );
};

export async function loader({ params }) {
    const { companySlug } = params;

    if (hasToken()) {
        return null;
    }

    return { slug: companySlug, name: companySlug };
}
